import React from 'react';
import { ListGroup } from 'react-bootstrap';

export const AllowanceListItem: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => (
  <ListGroup.Item className="d-flex align-items-center justify-content-between px-0">
    {children}
  </ListGroup.Item>
);
